/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d

export const BRAND_CONFIG = {
  TCP: 'childrensplace.com',
  GYM: 'gymboree.com',
  SNJ: 'sugarandjade.com',
  PJP: 'pjplace.com',
};

const generateCanonicalUrl = ({ mismatched: token, isCa, withCountry, brand, linkId }) => {
  let countryPath = '';
  let subDomain = 'www';

  if (!withCountry) {
    countryPath = isCa ? '/ca/' : '/us/';
  }

  if (linkId === 'fr-ca' || linkId === 'es-us') {
    subDomain = isCa ? 'fr' : 'es';
  }

  return `https://${subDomain}.${BRAND_CONFIG[brand]}${countryPath}c/${token}`;
};

// Function to handle US links
const handleUsLinks = (mismatched, links, withCountry, brand) => {
  if (mismatched) {
    return links.map((link) =>
      ['en-ca', 'fr-ca'].includes(link.id)
        ? {
            ...link,
            canonicalUrl: generateCanonicalUrl({
              mismatched,
              isCa: true,
              withCountry,
              brand,
              linkId: link.id,
            }),
          }
        : link
    );
  }
  return links.filter((link) => ['en-us', 'es-us'].includes(link.id));
};

// Function to handle CA links
const handleCaLinks = (mismatched, links, withCountry, brand) => {
  if (mismatched) {
    return links.map((link) =>
      ['en-us', 'es-us'].includes(link.id)
        ? {
            ...link,
            canonicalUrl: generateCanonicalUrl({
              mismatched,
              isCa: false,
              withCountry,
              brand,
              linkId: link.id,
            }),
          }
        : link
    );
  }
  return links.filter((link) => ['en-ca', 'fr-ca'].includes(link.id));
};

function addXDefault(finalLinks) {
  if (finalLinks?.length < 1) {
    return finalLinks;
  }

  const allCA = finalLinks.every((link) => link.id.endsWith('-ca'));
  const hasUS = finalLinks.some((link) => link.id.endsWith('-us'));

  if (allCA) {
    const enCaLink = finalLinks.find((link) => link.id === 'en-ca');
    if (enCaLink) {
      finalLinks.push({
        id: 'x-default',
        canonicalUrl: enCaLink.canonicalUrl,
      });
    }
  } else if (hasUS) {
    const enUsLink = finalLinks.find((link) => link.id === 'en-us');
    if (enUsLink) {
      finalLinks.push({
        id: 'x-default',
        canonicalUrl: enUsLink.canonicalUrl,
      });
    }
  }

  return finalLinks;
}

const urlsConfig = (context) => {
  const { brand, path, withCountry, seoTokenList } = context;
  let asPath = '';
  const totalPathCa = path?.split('/ca/');
  const totalPathUs = path?.split('/us/');

  if (totalPathUs.length > 1) {
    asPath = totalPathUs[totalPathUs.length - 1];
  }

  if (totalPathCa.length > 1) {
    asPath = totalPathCa?.[totalPathCa.length - 1];
  }
  if (path.indexOf('content/') > -1) {
    asPath = path;
  }

  const links = [
    {
      id: 'en-us',
      canonicalUrl: `https://www.${BRAND_CONFIG[brand]}${!withCountry ? '/us/' : ''}${asPath}`,
    },
    {
      id: 'es-us',
      canonicalUrl: `https://es.${BRAND_CONFIG[brand]}${!withCountry ? '/us/' : ''}${asPath}`,
    },
    {
      id: 'en-ca',
      canonicalUrl: `https://www.${BRAND_CONFIG[brand]}${!withCountry ? '/ca/' : ''}${asPath}`,
    },
    {
      id: 'fr-ca',
      canonicalUrl: `https://fr.${BRAND_CONFIG[brand]}${!withCountry ? '/ca/' : ''}${asPath}`,
    },
  ];

  const { us_href_lang: onlyUSHreflang, us_mismatched_hreflang: usMismatchedLang } =
    seoTokenList?.us || {};
  const { ca_href_lang: onlyCAHreflang, ca_mismatched_hreflang: caMismatchedLang } =
    seoTokenList?.ca || {};
  const { no_hreflang: noHrefLangToken } = seoTokenList?.noHref || {};
  let finalLinks;
  const usHrefLangLookup = onlyUSHreflang;
  const usMismatchedLookup = usMismatchedLang;
  const caHrefLangLookup = onlyCAHreflang;
  const caMismatchedLookup = caMismatchedLang;
  const tokenExistsInNoHrefLang = noHrefLangToken;
  const seoURLToken = asPath.split('/')[1];
  if (tokenExistsInNoHrefLang && tokenExistsInNoHrefLang[seoURLToken]) {
    finalLinks = []; // Don't create any links if found in no_hreflang
  } else if (usHrefLangLookup && usHrefLangLookup[seoURLToken]) {
    finalLinks = handleUsLinks(null, links, withCountry, brand);
  } else if (usMismatchedLookup && usMismatchedLookup[seoURLToken]) {
    finalLinks = handleUsLinks(usMismatchedLookup[seoURLToken], links, withCountry, brand);
  } else if (caHrefLangLookup && caHrefLangLookup[seoURLToken]) {
    finalLinks = handleCaLinks(null, links, withCountry, brand);
  } else if (caMismatchedLookup && caMismatchedLookup[seoURLToken]) {
    finalLinks = handleCaLinks(caMismatchedLookup[seoURLToken], links, withCountry, brand);
  } else {
    finalLinks = links;
  }

  finalLinks = addXDefault(finalLinks);
  if (brand?.toLowerCase() !== 'pjp' && brand?.toLowerCase() !== 'snj') {
    return finalLinks;
  }
  return [
    {
      id: 'en-us',
      canonicalUrl: `https://www.${BRAND_CONFIG[brand]}${!withCountry ? '/us/' : ''}${asPath}`,
    },
  ];
};

export default urlsConfig;
